export enum UserFormTabs {
  general = "general",
  // addresses = "addresses",
}
